import {
  DeprecatedZones,
  type SupportedTimeZoneIdentifier,
  type UnsupportedTimeZoneIdentifier,
  Zones,
} from './raw_data'
import type { IANATimezoneIdentifier } from './types'

/**
 * Get the `Zones` key for the given `timeZoneIdentifier`, in case `timeZoneIdentifier` is a deprecated name. If
 * `timeZoneIdentifier` has *never* been supported, returns `undefined`.
 */
export function canonicalIANATimezoneIdentifier(
  timeZoneIdentifier: IANATimezoneIdentifier
): SupportedTimeZoneIdentifier | undefined {
  if (timeZoneIdentifier in DeprecatedZones)
    return DeprecatedZones[timeZoneIdentifier as UnsupportedTimeZoneIdentifier]

  if (timeZoneIdentifier in Zones)
    return timeZoneIdentifier as SupportedTimeZoneIdentifier

  return
}
